import React, { useState, memo } from "react";
import { motion } from "framer-motion";
import { IoCloseSharp } from "react-icons/io5";

export const Popup = memo(({ children, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-[110]">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        transition={{ duration: 0.3 }}
        className="bg-white p-6 rounded-2xl shadow-2xl w-full max-w-xl relative"
      >
        <IoCloseSharp
          onClick={onClose}
          className="absolute top-4 right-4 text-2xl cursor-pointer hover:text-red-500 transition"
        />
        {children}
      </motion.div>
    </div>
  );
});

export const CourseDropdown = memo(({ courseList, onSelect }) => {
  const [clickedIndex, setClickedIndex] = useState(null);

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3 }}
      className="fixed left-3 right-3 top-24 z-[55] mx-auto max-h-[72vh] max-w-7xl overflow-y-auto rounded-3xl border border-gray-200 bg-white px-4 py-5 shadow-2xl sm:left-6 sm:right-6 sm:px-7 sm:py-7"
    >
      <motion.div
        initial="hidden"
        animate="show"
        variants={{
          hidden: { opacity: 1 },
          show: {
            opacity: 1,
            transition: { staggerChildren: 0.06 },
          },
        }}
        className="grid gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
      >
        {courseList.map((course, idx) => (
          <motion.div
            key={idx}
            variants={{
              hidden: { opacity: 0, y: 10 },
              show: { opacity: 1, y: 0 },
            }}
            whileHover={{ y: -4, scale: 1.02 }}
            onClick={() => {
              setClickedIndex(idx);
              setTimeout(() => {
                onSelect(course.route);
              }, 200);
            }}
            className="group relative flex min-h-[96px] cursor-pointer flex-col items-center justify-center overflow-hidden rounded-2xl bg-gradient-to-tr from-indigo-500 to-violet-600 px-4 py-4 text-center text-white shadow-lg transition-shadow duration-300 hover:shadow-xl"
          >
            <motion.p
              initial={{ opacity: 1 }}
              animate={clickedIndex === idx ? { opacity: 0 } : { opacity: 1 }}
              className="mb-1 break-words text-sm font-bold leading-snug text-white transition-colors group-hover:text-white"
            >
              {course.label}
            </motion.p>

            {course.trending && (
                <span className="mt-1 rounded-full bg-yellow-300 px-2 py-[2px] text-[10px] font-semibold text-yellow-900 shadow-sm">
                Recommended
              </span>
            )}
          </motion.div>
        ))}
      </motion.div>
    </motion.div>
  );
});
